import RightContent from '@/components/RightContent';
import { InfoCircleOutlined, LinkOutlined, SearchOutlined } from '@ant-design/icons';
import { type MenuDataItem, type Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import { Alert, App, ConfigProvider, Input, message, Modal } from 'antd';
import locale from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { debounce, throttle } from 'lodash';
import moment from 'moment';
import 'moment/locale/zh-cn';
import type { InspectParams } from 'react-dev-inspector';
import { Inspector } from 'react-dev-inspector';
import defaultSettings from '../config/defaultSettings';
import themeToken from '../config/themeToken';
// import Assistant from './components/Assistant';
import Footer from './components/Footer';
import NoticeAlert from './components/NoticeAlert';
import { LOCAL_STORAGE, URL_LOGIN, WINDOW_TARGET_ROUTES_NAME } from './constant';
import CustomBoundary from './pages/ErrorPage';
import { postCommonConfigGetRedNum } from './services/yizhe-web/gonggongfenlei';
import { postPostRouterBaobSettingPcSupplyConfig } from './services/yizhe-web/printcenter';
import { postBackendRoleGetWebMenus } from './services/yizhe-web/shouyeguanli';
import {
  postCommonUserGetUserInfo,
  postCommonUserTemporaryAuthorization,
} from './services/yizhe-web/yonghuguanli';
import { isPrintCenterFromOutside, navLogin, navMaintenance } from './utils/nav';
import { generateFormData, generateSign, removeFalsy } from './utils/sign';

// 全局节流函数：校验爆版登录态，30秒内只执行一次
const throttledCheckBaobanLogin = throttle(() => {
  try {
    postPostRouterBaobSettingPcSupplyConfig({}).then((res) => {
      console.log('校验爆版登录态', res);
      const currentPath = window.location.pathname;
      console.log('当前路径:', currentPath);
      if (res.code === -1 && !currentPath.includes('share-print-task')) {
        localStorage.removeItem('mhm_token');
        localStorage.removeItem('baoban_supplier');
        localStorage.removeItem('baoban_shop_id');
        // 爆版登录失败跳转到爆版
        history.replace(`${BAOBAN_URL}/goods/list`);
      }
    });
  } catch (error) {
    console.error('校验爆版登录态失败:', error);
  }
}, 30000); // 30秒节流

const messageErrorCustom = (msg: string, config?: any) => {
  message.error({
    content: <span dangerouslySetInnerHTML={{ __html: msg }} className="ant-message-error-msg" />,
    className: 'message-error-custom',
    ...config,
  });
};
const { confirm } = Modal;
moment.locale('en');

dayjs.locale('zh-cn');
const isDev = process.env.NODE_ENV === 'development';

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.GetUserInfoResult['data'];
  currentMenus?: API.GetWebMenusResult['data'];
  redNum?: API.GetRedNumResult['data'];
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.GetUserInfoResult['data'] | undefined>;
  fetchRoleMenus?: () => Promise<API.GetWebMenusResult['data']>;
  fetchRedNum?: () => Promise<API.GetRedNumResult['data'] | undefined>;
  isInitOpenConfig?: boolean; // 初始化routes标识 目的是在第一次渲染菜单的时候筛选出默认收起的菜单
  openKeys?: string[]; // 展开的keys
  menuSearchKeyWord?: string; // 菜单搜索关键词
}> {
  // 获取url参数
  const urlParams = new URL(window.location.href);
  const { pathname } = urlParams;
  const from = urlParams.searchParams.get('from') || '';
  console.log('isPrintCenterFromOutside=============', from, pathname);

  if (from && from === 'baoban') {
    const supplier = urlParams.searchParams.get('supplier') || '';
    localStorage.setItem('baoban_supplier', supplier);
    let token = decodeURIComponent(urlParams.searchParams.get('token') || '');
    // 处理app_user_name中文
    const tokenJson = JSON.parse(token);
    tokenJson.app_user_name = encodeURIComponent(tokenJson.app_user_name);
    token = JSON.stringify(tokenJson);
    localStorage.setItem('mhm_token', token);
    const shopId = urlParams.searchParams.get('shopId') || '';
    localStorage.setItem('baoban_shop_id', shopId);
  } else if (from) {
    localStorage.removeItem('baoban_supplier');
    localStorage.removeItem('mhm_token');
    localStorage.removeItem('baoban_shop_id');
  }

  const fetchUserInfo = async () => {
    // console.log(initialState?.currentUser);
    try {
      const msg = await postCommonUserGetUserInfo({});
      return msg?.data;
    } catch (error) {
      // 如果打印中心来源不是外部，则跳转到登录页面
      if (!isPrintCenterFromOutside()) {
        history.push(URL_LOGIN);
      }
    }
    return undefined;
  };
  const fetchRoleMenus = async () => {
    try {
      const msg = await postBackendRoleGetWebMenus({});
      return msg?.data || [];

      //   const userInfo: any = localStorage.getItem('userInfo');
      //   const msg = JSON.parse(userInfo);
    } catch (error) {
      // 如果打印中心来源不是外部，则跳转到登录页面
      if (!isPrintCenterFromOutside()) {
        history.push(URL_LOGIN);
      }
    }
    return [];
  };
  const fetchRedNum = async () => {
    try {
      const info: any = JSON.parse(localStorage.getItem(LOCAL_STORAGE.tokenInfo) || '{}');
      if (info.token) {
        const msg = await postCommonConfigGetRedNum({});
        localStorage.setItem('redNum', JSON.stringify(msg?.data)); // 缓存存储一份,更新红点用
        return msg?.data;
      } else {
        return undefined;
      }
    } catch (error) {
      return undefined;
    }
  };

  // 如果不是登录页面,执行
  if (pathname !== URL_LOGIN) {
    const info: any = JSON.parse(localStorage.getItem(LOCAL_STORAGE.tokenInfo) || '{}');
    console.log('🚀 ~ file: app.tsx ~ line 37 ~ getInitialState ~ info', info);
    let currentUser: any;
    if (info.token) {
      currentUser = await fetchUserInfo();
    }
    let currentMenus: API.GetWebMenusResult['data'] = [];
    let redNum;
    // 用户信息对象长队为零说明还没进行登录
    if (Object.keys(currentUser || {}).length !== 0) {
      if (info.token) {
        currentMenus = await fetchRoleMenus();
        redNum = await fetchRedNum();
      }
    }
    return {
      fetchUserInfo,
      fetchRoleMenus,
      fetchRedNum,
      currentUser,
      settings: defaultSettings,
      currentMenus,
      redNum,
      menuSearchKeyWord: '',
    };
  }

  return {
    fetchUserInfo,
    fetchRedNum,
    fetchRoleMenus,
    settings: defaultSettings,
    isInitOpenConfig: true,
    openKeys: [],
    menuSearchKeyWord: '',
  };
}
// 与后端约定的响应数据格式

console.log('当前环境', process.env.NODE_ENV);

// // 请求拦截
const requestInterceptors = (config: any) => {
  //   console.log('请求拦截', config);
  // 设置代理前缀/api
  let url = config.url;
  //   console.log("请求地址", url);
  if (process.env.NODE_ENV === 'development' && !config.isMhm && !config.isBaoban) {
    url = `/api${url}`;
  }
  // 打包后
  if (process.env.NODE_ENV === 'production' && !config.isMhm && !config.isBaoban) {
    // 判断是否测试环境
    console.log('当前地址', window.location);
    let origin = window.location.origin;
    // api-test scm-test
    if (origin.indexOf('scm-test') > -1) {
      origin = origin.replace('scm-test', 'api-test');
      console.log('最新地址', origin);
      url = `${origin}${url}`;
    } else {
      url = `${API_URL}${url}`;
    }
  }
  // 校验爆版登录态 - 使用节流函数
  if (
    !config.checkBaoban &&
    (config.isMhm || config.isBaoban) &&
    localStorage.getItem('baoban_supplier')
  ) {
    setTimeout(() => {
      throttledCheckBaobanLogin();
    }, 300);
  }
  if (config.isMhm) {
    if (localStorage.getItem('mhm_token')) {
      config.headers = {
        ...config.headers,
        Authorization: `${localStorage.getItem('mhm_token')}`,
      };
    }
    url = `${MHM_API_URL}${url}`;
  }

  if (config.isBaoban) {
    url = `${BAOBAN_API_URL}${url}`;
    config.headers = {
      ...config.headers,
      supplier: `${localStorage.getItem('baoban_supplier')}`,
      'Content-Type': 'multipart/form-data',
      Shopid: localStorage.getItem('baoban_shop_id'),
    };
    if (BAOBAN_LOCAL_ENV) {
      config.headers['Local-Env'] = BAOBAN_LOCAL_ENV;
    }
    const timestamp = Math.floor(Date.now() / 1000);
    let requestData = config.method.toLowerCase() === 'get' ? config.params : config.data;
    requestData = {
      ...requestData,
      timestamp,
    };
    console.log('requestData', removeFalsy(requestData), process.env.NODE_ENV);
    const sign = generateSign(removeFalsy(requestData));
    if (config.method.toLowerCase() === 'get') {
      config.params = generateFormData({
        ...requestData,
        sign,
      });
    } else {
      config.data = generateFormData({
        ...requestData,
        sign,
      });
    }
  }
  const obj: RequestConfig = config;
  const cv = '4.7.0';
  if (
    config.url !== '/common/login/login' &&
    config.url !== '/common/login/send_verify_code' &&
    !config.isMhm &&
    !config.isBaoban
  ) {
    // 请求参数带上公共参数
    const tokenInfo: any = localStorage.getItem(LOCAL_STORAGE.tokenInfo);
    const { token, cid, uid } = JSON.parse(tokenInfo) || {};
    const v = localStorage.getItem('version');
    // TODO: 上传图片兼容
    if (obj.url === '/common/upload/upload_image') {
      obj.params = {
        ...obj.params,
        token,
        cid,
        uid,
        plate_type: 'backend',
        v,
        cv,
      };
    } else {
      obj.data = {
        ...obj.data,
        token,
        cid,
        uid,
        plate_type: 'backend',
        v,
        cv,
      };
    }
  }
  return { ...obj, url };
};
const updateVersionCallBack = debounce(function (msg: string) {
  const isUpdateVersion = localStorage.getItem('updateVersion');
  console.log('isUpdateVersion', isUpdateVersion);
  if (isUpdateVersion === '1') {
    localStorage.setItem('isUpdateVersion', '0');
    // message.error(msg);
    messageErrorCustom(msg);
    setTimeout(() => {
      location.reload();
    }, 1000);
  }
}, 1000);
// // 响应拦截
const responseInterceptors = (response: any) => {
  const res = response;

  // 如果是二进制响应（如文件下载），直接返回
  if (res?.config?.responseType === 'blob') {
    console.log('检测到 blob 响应，直接返回：', {
      responseType: res?.config?.responseType,
      dataType: typeof res?.data,
      isBlob: res?.data instanceof Blob,
      size: res?.data?.size,
      url: res?.config?.url,
    });
    return response;
  }

  const { code, v, msg } = res?.data;
  //   console.log('🚀 ~ file: app.tsx ~ line 138 ~ responseInterceptors ~ res?.data', res?.data);
  // 记录接口返回的版本字符串
  if (v) {
    localStorage.setItem('version', v);
  }
  //   localStorage.setItem('update', '');
  //   console.log(4444, history.location);

  if (`${code}` !== '200') {
    if (`${code}` === '201') {
      localStorage.removeItem(LOCAL_STORAGE.version);
      localStorage.removeItem(LOCAL_STORAGE.redNum);
      localStorage.removeItem(LOCAL_STORAGE.userInfo);
      navLogin();
      //   message.error(msg);
      messageErrorCustom(msg);
      return response;
    }
    // 跳转停机页面
    if (`${code}` === '503') {
      // 系统停机维护
      navMaintenance();
      return response;
    }
    // 会员过期拦截
    if (`${code}` === '402') {
      confirm({
        title: 'vip过期',
        content: '您的VIP已到期,当前功能无法使用,请购买续费后使用完整功能,联系电话:180 2957 5364',
        //   okText: '立即续费',
        onOk() {
          // history.push('/payment');
        },
      });
      //   message.error(msg);
      messageErrorCustom(msg);
      return response;
    }
    // // 版本更新
    if (`${code}` === '309') {
      localStorage.setItem('updateVersion', '1');

      updateVersionCallBack(msg);
      return response;
    }
    if (`${code}` === '411') {
      return response;
    }
    // 仅卖货猫、爆版接口拦截400、-1、1
    if (
      (`${code}` === '400' || code === -1 || code === 1) &&
      (response.config.isMhm || response.config.isBaoban)
    ) {
      console.log('400', response);
      return response;
    }
    // } else {
    //   message.error(msg);
    // }
    // message.error(msg);
    messageErrorCustom(msg);
  }

  //   console.log("response", response);
  //   const updateHotDot = [
  //     'common/instock/get_instock_record',
  //     'common/follow_order/get_follow_order_detail',
  //     'common/purchase/get_purchase_detail',
  //   ];
  //   if (~updateHotDot.indexOf(response.config.url)) {

  //     getInitialState().then((res) => {
  //       console.log(1111, res);
  //     });
  //   }

  return response;
};
// 错误处理方案: 错误类型
// enum ErrorShowType {
//   SILENT = 0,
//   WARN_MESSAGE = 1,
//   ERROR_MESSAGE = 2,
//   NOTIFICATION = 3,
//   REDIRECT = 9,
// }
interface ResponseStructure {
  code: string;
  data: any;
  msg: string;
}
export const request: RequestConfig = {
  requestInterceptors: [requestInterceptors],
  responseInterceptors: [responseInterceptors],
  timeout: 120000,
  errorConfig: {
    errorHandler: (error: any, opts: any) => {
      console.log('errorHandler', error, opts);
      if (opts?.skipErrorHandler || opts?.isMhm) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.name === 'BizError') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { msg } = errorInfo;
          //   message.error(msg);
          messageErrorCustom(msg);
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        message.error(`Response status:${error.response.status}`);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        message.error('None response! Please retry.');
      } else {
        // 发送请求时出了点问题
        message.error('服务器异常，请稍后重试');
      }
    },
    // 错误抛出
    errorThrower: (res: any) => {
      console.log('错误抛出', res);
      const { code, data, msg } = res;
      if (code !== '200') {
        const error: any = new Error(msg);
        error.name = 'BizError';
        error.info = { code, msg, data };
        throw error; // 抛出自制的错误
      }
    },
  },
};
// 小红点
function getRedHotItem(data: any) {
  let resultNum = '';
  //   const redNum = initialState?.redNum;
  let redNum: API.GetRedNumResult['data'];
  switch (data.name) {
    case '样板管理':
      redNum = JSON.parse(localStorage?.getItem(LOCAL_STORAGE.redNum) || '{}');
      resultNum = redNum?.template_red_num || '';
      break;
    case '成衣入库':
      redNum = JSON.parse(localStorage?.getItem(LOCAL_STORAGE.redNum) || '{}');
      resultNum = redNum?.stock_in_red_num || '';
      break;
    case '采购列表':
      redNum = JSON.parse(localStorage?.getItem(LOCAL_STORAGE.redNum) || '{}');
      resultNum = redNum?.purchase_red_num || '';
      break;
    case '跟单管理':
      redNum = JSON.parse(localStorage?.getItem(LOCAL_STORAGE.redNum) || '{}');
      resultNum = redNum?.follow_order_red_num || '';
      break;

    default:
      break;
  }
  return resultNum;
}
// 菜单搜索
const filterByMenuData = (data: MenuDataItem[], keyWord: string): MenuDataItem[] => {
  return data
    .map((item) => {
      if (!keyWord) return item;
      if (item.name?.includes(keyWord)) {
        return { ...item };
      }
      const children = filterByMenuData(item.children || [], keyWord);
      if (children.length > 0) {
        return { ...item, children };
      }
      return undefined;
    })
    .filter((item) => item) as MenuDataItem[];
};

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  const exceptArr = ['/payment', '/print-ticket', '/print-order'];
  const isShow = !exceptArr.includes(history.location.pathname);
  //   const inputRef = useRef(null);
  //   const { reload } = useModel('menu');
  let expire_les_time: any = 0;
  //   console.log('剩余天数', expire_les_time);
  if (initialState?.currentUser) {
    // 记录每天请求一次vip剩余天数
    const today = moment().format('YYYY-MM-DD');
    const isHasRequest = sessionStorage.getItem(today) || '';
    // TODO: 没有实时更新数据,待处理
    if (!isHasRequest && initialState.fetchUserInfo) {
      initialState?.fetchUserInfo()?.then((res: any) => {
        console.log('刷新数据', res);
        setInitialState((s) => ({ ...s, currentUser: res }));
        sessionStorage?.setItem(today, res?.company_info?.expire_les_time);
        expire_les_time = res?.company_info?.expire_les_time;
      });
    } else {
      expire_les_time = initialState?.currentUser?.company_info?.expire_les_time || 0;
    }
  }
  const isOpenMunuSearch = Boolean(localStorage.getItem('isOpenMunuSearch'));

  //   const handleKeyDown = (e) => {
  //     if (e.ctrlKey && e.key === 'k') {
  //       console.log(1111111, inputRef);
  //     }
  //   };

  //   document.addEventListener('keydown', handleKeyDown);

  return {
    rightContentRender: () => (
      <>
        {!isPrintCenterFromOutside() && (
          <ConfigProvider theme={themeToken}>
            <RightContent />{' '}
          </ConfigProvider>
        )}
      </>
    ),
    disableContentMargin: false,
    // headerContentRender: <ProBreadcrumb />,
    menuItemRender: (item, dom, { collapsed }) => {
      const num = getRedHotItem(item);
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            // paddingLeft: 8,
          }}
          onClick={async () => {
            if (WINDOW_TARGET_ROUTES_NAME.includes(item?.name || '')) {
              window.open(item?.itemPath);
            } else if (item?.name === '工厂超市') {
              const { data, code } = await postCommonUserTemporaryAuthorization({});
              if (code === '200') {
                open(`${FS_URL}/login/transfer?authorToken=${data?.authorization_key}&appType=1`);
              }
            } else {
              history.push(item?.itemPath);
            }
          }}
        >
          <span>{dom}</span>
          {item.hasRedHot && !collapsed && num !== '' && num !== '0' ? (
            <span className="red-dot">{num}</span>
          ) : null}
        </div>
      );
    },
    menuExtraRender: ({ collapsed }) =>
      !collapsed &&
      isOpenMunuSearch && (
        <Input
          style={{
            borderRadius: 4,
            backgroundColor: 'rgba(0,0,0,0.03)',
          }}
          prefix={
            <SearchOutlined
              style={{
                color: 'rgba(0, 0, 0, 0.15)',
              }}
            />
          }
          placeholder="搜索菜单"
          onPressEnter={(e) => {
            setInitialState((s) => ({
              ...s,
              menuSearchKeyWord: (e.target as HTMLInputElement).value,
            }));
          }}
        />
      ),
    postMenuData: (menus) => filterByMenuData(menus || [], initialState?.menuSearchKeyWord || ''),
    contentStyle: {
      paddingTop: expire_les_time <= 15 && isShow ? 20 : 0,
      //   minHeight:'100%'
      //   marginTop: 24,
    },
    autoClose: false, //选中菜单是否自动关闭菜单
    onOpenChange: (keys: any): void => {
      //   const newOpenKeys: string[] = [];
      //   if (initialState?.isInitOpenConfig) {
      //     setInitialState({
      //       ...initialState,
      //       openKeys: keys,
      //     });
      //   } else {
      //     menuData.map((item: any) => {
      //       if (!item.defaultCollapsed) {
      //         newOpenKeys.push(item.path);
      //       }
      //     });
      //     setInitialState({
      //       ...initialState,
      //       openKeys: newOpenKeys,
      //       isInitOpenConfig: true,
      //     });
      //   }
    },

    // openKeys:  MENU_OPEN_ROUTES

    footerRender: () => (
      <div>
        <Footer />
        {(initialState?.currentUser?.company_info?.expire_les_time || 0) <= 15 &&
          isShow &&
          !isPrintCenterFromOutside() && (
            <NoticeAlert
              key={new Date().getTime()}
              expire_les_time={initialState?.currentUser?.company_info?.expire_les_time || 0}
            />
          )}
        {/* <Assistant /> */}
      </div>
    ),
    onPageChange: () => {
      //重置滚动位置
      window.document.getElementById('root')?.scrollIntoView(true);
      const { location } = history;
      if (
        Object.keys(initialState?.currentUser || {}).length === 0 &&
        location.pathname.indexOf(URL_LOGIN) === -1
      ) {
        // 如果打印中心来源不是外部，则跳转到登录页面
        if (!isPrintCenterFromOutside()) {
          history.push(URL_LOGIN);
        }
      }
      if (initialState && initialState.fetchRedNum) {
        initialState?.fetchRedNum();
      }
    },
    links: isDev
      ? [
          <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
            <LinkOutlined />
            <span>接口文档</span>
          </Link>,
          //   <a
          //     onClick={async () => {
          //       const { data, code } = await postCommonUserTemporaryAuthorization({});
          //       if (code === '200') {
          //         open(`${FS_URL}/login/transfer?authorToken=${data?.authorization_key}&appType=1`);
          //       }
          //     }}
          //   >
          //     {' '}
          //     工厂超市
          //   </a>,
        ]
      : [],
    menuHeaderRender: undefined,
    ErrorBoundary: CustomBoundary,
    headerContentRender: (props) => {
      const headerLogo = document.getElementsByClassName('ant-pro-global-header-logo')[0];
      if (headerLogo && props.collapsed) {
        headerLogo?.classList.add('new-header-logo');
      } else {
        headerLogo?.classList.remove('new-header-logo');
      }
      return undefined;
    },
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <App>
          <ConfigProvider locale={locale} theme={themeToken}>
            {isDev && (
              <Inspector
                // props see docs:
                // https://github.com/zthxxx/react-dev-inspector#inspector-component-props
                keys={['z', 'shift', 'x', 'c']}
                disableLaunchEditor={true}
                onClickElement={({ codeInfo }: InspectParams) => {
                  if (!codeInfo?.absolutePath) return;
                  const { absolutePath, lineNumber, columnNumber } = codeInfo;
                  // you can change the url protocol if you are using in Web IDE
                  window.open(`cursor://file/${absolutePath}:${lineNumber}:${columnNumber}`);
                }}
              >
                <div />
              </Inspector>
            )}
            {initialState?.redNum?.top_message && (
              <Alert
                icon={
                  <InfoCircleOutlined
                    style={{ fontSize: 20, color: initialState?.redNum?.top_message?.color }}
                  />
                }
                message={
                  <div style={{ textAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>
                    {initialState?.redNum?.top_message?.message}
                  </div>
                }
                style={{
                  width: '100%',
                  position: 'sticky',
                  top: '56px',
                  cursor: 'pointer',
                  zIndex: 999,
                  color: initialState?.redNum?.top_message?.color,
                  transition: 'left 0.2s, width 0.2s',
                  background: initialState?.redNum?.top_message?.background,
                }}
                banner={true}
              />
            )}
            {children}
            {/* {!props.location?.pathname?.includes('/login') && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={false}
              //   settings={initialState?.settings}
              colorList={false}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )} */}
          </ConfigProvider>
        </App>
      );
    },
    ...initialState?.settings,
  };
};
